// GA session handoff for the UK storefront.
//
// The .co.uk storefront and the customer-account domain (my.fashionphile.com)
// are different registrable domains, so GA cookies cannot cross the hop and
// every UK visit to the account pages started a brand-new "direct" session.
// The gtag _gl linker can't be used either: the receiving tag runs inside the
// Shopify web-pixel sandbox and cannot read the real page URL at init.
//
// At click time on any cross-site fashionphile.com link, this serializes the
// GA cookies (_ga + all _ga_* stream cookies) into an _fpl URL parameter. The
// custom pixel (applySessionHandoff in the pixel editor's analytics.js)
// validates and rehydrates them before gtag initializes, so the storefront
// session — and its channel attribution — continues on the account domain.
(function () {
  if (!window.location.hostname.endsWith(".co.uk")) {
    return;
  }

  function collectGaCookies() {
    const cookies = {};
    document.cookie.split("; ").forEach((pair) => {
      const separatorIndex = pair.indexOf("=");
      if (separatorIndex === -1) return;
      const name = pair.slice(0, separatorIndex);
      if (name === "_ga" || /^_ga_[A-Z0-9]+$/.test(name)) {
        cookies[name] = decodeURIComponent(pair.slice(separatorIndex + 1));
      }
    });
    return cookies;
  }

  function base64UrlEncode(value) {
    return btoa(value).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }

  document.addEventListener(
    "click",
    (event) => {
      const anchor = event.target?.closest?.("a[href]");
      if (!anchor) return;

      let url;
      try {
        url = new URL(anchor.href, window.location.origin);
      } catch (e) {
        return;
      }
      const isCrossSiteFashionphile = url.hostname === "fashionphile.com" || url.hostname.endsWith(".fashionphile.com");
      if (!isCrossSiteFashionphile) return;

      const gaCookies = collectGaCookies();
      if (!gaCookies._ga) return;

      url.searchParams.set("_fpl", base64UrlEncode(JSON.stringify({ g: gaCookies, t: Date.now() })));
      anchor.href = url.toString();
    },
    true,
  );
})();
